// JsFromRoutes CacheKey 73792ff8094bb0315349a44e4c902ac5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  profile: /* #__PURE__ */ definePathHelper('get', '/my-account/profile'),
  giftPreferences: /* #__PURE__ */ definePathHelper('get', '/my-account/gift-preferences'),
  purchases: /* #__PURE__ */ definePathHelper('get', '/my-account/purchases'),
  billing: /* #__PURE__ */ definePathHelper('get', '/my-account/billing'),
  settings: /* #__PURE__ */ definePathHelper('get', '/my-account/settings'),
  favorites: /* #__PURE__ */ definePathHelper('get', '/my-account/favorites'),
  publishedGiftsDrafts: /* #__PURE__ */ definePathHelper('get', '/my-account/published-gifts-drafts'),
  deleteDraft: /* #__PURE__ */ definePathHelper('delete', '/my-account/draft/:internal_slug'),
  resetPassword: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/reset_password'),
  updateInfo: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/update_info'),
  updateSettings: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/update_settings'),
  deleteAccount: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/delete_account'),
  checkUsername: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/check_username'),
  suggestUsername: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/suggest_username'),
  confirmUsername: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/confirm_username'),
  optOutUsername: /* #__PURE__ */ definePathHelper('post', '/consumer/my_account/opt_out_username'),
  removeCreditCard: /* #__PURE__ */ definePathHelper('delete', '/consumer/my_account/remove_credit_card'),
}
